const index = {
    buttons: require("./buttons.json"),
    labels: require("./labels.json"),
    menus: require("./menus.json"),
};

export default index;
